import { useSuspenseQuery } from '@apollo/client';
import { GET_TODOS } from '../graphql/queries';
import { ToDoRowModel } from '../../components/Table/ToDoTable/entities/Entities';
import { getToDosArbeitszeiten } from './getToDosArbeitszeiten';
import { getToDoAntraege } from './getToDosAntraege';
import { getToDosKonflikte } from './getToDosKonflikte';

export type UseToDosResult = {
  toDos: ToDoRowModel[] | undefined;
  error: Error | undefined;
};

export function useToDos(Datum: string, standortId: string): UseToDosResult {
  const { data, error } = useSuspenseQuery(GET_TODOS, {
    variables: { Datum, standortId },
    fetchPolicy: 'no-cache',
  });

  const toDosArbeitszeiten = getToDosArbeitszeiten({ data });
  const toDosAntraege = getToDoAntraege({ data });
  const toDosKonflikte = getToDosKonflikte({ data });

  return {
    toDos: [...toDosArbeitszeiten, ...toDosKonflikte, ...toDosAntraege],
    error,
  };
}
